<template>

    <div class="message">
        <!--   -->
        <div class="newsTip" @click="onRefresh" :class="newsTip?'top-20':'top--100'"><img src="../../assets/index/xiaoxi@2x.png" class="xiaoxi" />您有新消息</div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="nav-box">
                <div class="left-text"  >消息通知</div>
                <div class="right-text" @click="onMessageReadAll">全部已读</div>
            </div>
            <div class="navlist-box">
                <tab :tabList="dataTab" ref="tab" :name="'dataTab'" @onSwitch="myPending"></tab>

            </div>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMoreList"
                v-if="listdata.length > 0">
                <div class="msg-list-box" v-if="listdata.length > 0">
                    <div class="items-box" v-for="(lists,index) in listdata" :key="index"
                        @click="goDealDetail(lists.disposeUrl,lists.moduleCode, lists)">
                        <div class="title-box" @click="onMessageReadOne(lists.isRead,lists.id)">
                            <div class="category-box">
                                <div class="img-box">
                                    <img src="../../assets/index/ic_kaohe.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '1'" />
                                    <img src="../../assets/index/ic_toushu.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '2'" />
                                    <img src="../../assets/index/ic_tuihuo.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '3'" />
                                    <img src="../../assets/index/ic_daoyou.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '4'" />
                                    <img src="../../assets/index/ic_chengxin.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '5'" />
                                    <img src="../../assets/index/ic_lvxingshe.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '6'" />
                                    <img src="../../assets/index/ic_gonggao.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '7'" />
                                     <img src="../../assets/index/ic_team.png" alt="" class="back-img"
                                        v-if="lists.moduleCode == '24'" />
                                    <img src="../../assets/index/ic_redpoint.png" alt="" class="red-img"
                                        v-if="!lists.isRead" />
                                </div>
                                <div class="text-box">{{lists.moduleName}}</div>
                            </div>
                            <div class="times-box">{{lists.messageTime}}</div>
                        </div>
                        <rline />
                        <div class="content-box" @click="onMessageReadOne(lists.isRead,lists.id)">
                            <h5 class="news-title">{{lists.title}}</h5>
                            <p class="news-text">{{lists.content}}</p>
                        </div>
                        <rline v-if="lists.disposeUrl" />
                        <div class="do-box" v-if="lists.disposeUrl" @click="onMessageReadOne(lists.isRead,lists.id)">
                            <div class="do-text">立即查看</div>
                            <img src="../../assets/index/ic_bm_jt.png" alt="" class="right-icon" />
                        </div>

                    </div>
                </div>
            </van-list>
            <empty :type="3" v-if="listdata.length === 0 && !loading"></empty>
        </van-pull-refresh>
    </div>

</template>

<script>
    import tab from 'comps/tab-event'
    import api from '../../service/modules/message'
    import Ap1Worker from '../../service/modules/complaintApis'
    import empty from 'comps/empty';
    import rline from '../travelAgency/components/line.vue'
    import util from '../../utils/common'
    import { openWindow, getUrlQuery } from '../../utils/helper'
    export default {
        components: {
            tab,
            empty,
            rline

        },
        data () {
            return {
                count: 0,
                disposeUrl: '',
                dataTab: [{
                    'code': '',
                    'name': '全部',
                    'quantity': 0
                }, 
                {
                    'code': '2',
                    'name': '投诉',
                    'quantity': 0
                },
                {
                    'code': '3',
                    'name': '退货',
                    'quantity': 0
                },
                {
                    'code': '5',
                    'name': '诚信',
                    'quantity': 0
                },
                {
                    'code': '6',
                    'name': '旅行社',
                    'quantity': 0
                },
                {
                    'code': '4',
                    'name': '导游',
                    'quantity': 0
                },
                {
                    'code': '1',
                    'name': '考核平台',
                    'quantity': 0
                },
                {
                    'code': '7',
                    'name': '招商',
                    'quantity': 0
                }],
                listdata: [],
                moduleCode: '',
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                isLoading: false,
                lastId: '', // 分页最后一条id
                startId: '', // 最新id
                newsTip: false, // 新消息
                scrollTop: 0,
                userInfo:'',
                areaId: ''
            }
        },
        computed: {

        },
        watch: {

        },

        methods: {
            scroll (e) {
                let {
                    scrollTop
                } = e.target;
                this.scrollTop = scrollTop
            },
            onRefresh () {
                this.isLoading = false;
                this.moduleCode = ''
                this.total = 0;
                this.listdata = [];
                this.page = 1;
                this.lastId = ''
                this.newsTip = false
                this.$refs.tab.switchTab(0)
                this.getUnreadQuantity()
                this.getInitData();
            },
            loadMoreList () {
                this.getInitData();
            },
            myPending (code) {
                this.moduleCode = code;
                this.total = 0;
                this.listdata = [];
                this.page = 1;
                this.lastId = ''
                this.getInitData()

                // 如果是招商模块，角色为'项目管理角色governmentStacff'才接受信息
                if (code === 7) {
                    if (this.$store.state.investment.isGovernmentStacff) {
                        this.getInitData()
                    }
                } else {
                        this.getInitData()
                }
            },
            getInitData () {
                let data = {
                    moduleCode: this.moduleCode,
                    lastId: this.lastId,
                    pageSize: 10
                }
                this.loading = true;
                api.messageList(data).then(res => {
                    if (res.ret === 0) {
                        if (this.lastId === '' && this.moduleCode === '') {
                            if (res.data.list.length > 0) {
                                this.startId = res.data.list[0].id
                            }
                        }
                        this.finished = false;
                        this.listdata = [...this.listdata, ...res.data.list];

                        if (res.data.list && res.data.list.length > 0) {
                            this.lastId = res.data.list[res.data.list.length - 1].id
                        } else {
                            this.finished = true;
                        }
                        this.loading = false;
                    }
                })
            },
            // 消息全部已读
            onMessageReadAll () {
                api.messageReadAll({}).then(res => {
                    if (res.ret === 0) {
                        this.listdata.map((items, index) => {
                            if (!items.isRead) {
                                items.isRead = true
                            }
                        })
                    }
                })
            },
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                console.log('点击的立即查看按钮触发的事件');
                if (!isRead) {
                    api.messageReadOne({
                        messageId: id
                    }).then(res => {
                        if (res.ret === 0) {
                            this.listdata.map((items, index) => {
                                if (items.id === id) {
                                    items.isRead = true
                                }
                            })
                        }
                    })
                }
            },
            // 立即处置
            goDealDetail (disposeUrl, moduleCode, item) {
                console.log('点击的外层事件，非内容包含事件');
                this.disposeUrl = disposeUrl
                if (moduleCode === 2) {// 投诉的
                    // let type = this.getQueryString('type')
                    // let mainComplainNumber = this.getQueryString('main_complain_number')
                    // this.init(type, mainComplainNumber)
                    if (disposeUrl) {
                        openWindow(item.title, disposeUrl)
                    } else {
                        console.log('新版不支持旧版')
                    }
                    
                } else {
                    if (moduleCode === 3) {
                        util.setJsonLocal('flowId', this.getQueryString('flowId'));
                    }
                    if (disposeUrl) {
                        if (disposeUrl.includes('/team-supervision/supervision-app/#/cockpit_app/PrivateInfoDetail') && disposeUrl.includes('{')) {
                            let url = disposeUrl
                            let query = getUrlQuery(url)
                            let newQuery = []
                            for(let k in query) {
                                if (k === 'data') {
                                    newQuery.push(`${k}=${encodeURIComponent(query[k])}`)
                                } else {
                                    newQuery.push(`${k}=${query[k]}`)
                                }
                            }
                            disposeUrl = url.split('?')[0] + '?'+ newQuery.join('&')
                        }
                        window.yyn.invokeJSB(
                            'openWindow', {
                                openUrl: disposeUrl,
                                isFullScreen: 0,
                                setTitle: '',
                                needLoading: 1
                            },
                            cb => {
                                console.log(cb, 'callback');
                            }
                        );
                    }
                }
            },
            getQueryString (name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = this.disposeUrl.substr(this.disposeUrl.indexOf('?') + 1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            init (type, mainComplainNumber) {
                let inputParams = mainComplainNumber
                this.inputParams = inputParams
                // this.$store.commit('complaint/setHandleWorkbench', true)
                this.getUserInfo()
                this.getQuery(type, inputParams)
            },
            async getUserInfo () {
                // 获取用户信息
                await Ap1Worker.common.user({}).then(res => {
                    if (res.ret == 0) {
                        this.userInfo=res.data;
                        this.areaId = res.data.depts[0].txId;
                        this.$store.commit('complaint/setUserInfo', res.data);
                        // callback && callback();
                    }
                })
            },
            async getQuery (type, inputParams) {
                switch (type) {
                case 'centerAccepted'://指挥中心待响应
                    util.setJsonLocal('buttonType','centerAccepted');
                    util.setJsonLocal('waitResponse','centerAccepted');
                    await this.getNotAcceptComplainList('notAcceptComplainList', inputParams)
                    break
                case 'centerHandle'://指挥中心待处理
                    util.setJsonLocal('buttonType','centerHandle');
                    util.setJsonLocal('waitResponse','centerHandle');
                    await this.getNotHandleComplainList('notHandleComplainList', inputParams)
                    break
                case 'depCompanyHandle'://待处理（部门/企业）
                    util.setJsonLocal('buttonType','depCompanyHandle');
                    util.setJsonLocal('waitResponse','depCompanyHandle');
                    await this.getlistDepEnterpriseAwaitHandle('notHandleComplainList', inputParams)
                    break    
                case 'reportIng'://指挥中心，上报待审核
                    util.setJsonLocal('buttonType','reportIng');
                    util.setJsonLocal('waitResponse','reportIng');
                    await this.getListAwaitReport('awaitReportlist', inputParams)
                    break
                case 'superviseHandle'://指挥中心.督办待受理
                    util.setJsonLocal('buttonType','superviseHandle');
                    util.setJsonLocal('waitResponse','superviseHandle'); 
                    await this.getListSuperviseToAccept('superviseToAcceptList', inputParams)
                    break
                case 'splitOrderReportIng'://指挥中心.拆单待审核
                    util.setJsonLocal('buttonType','splitOrderReportIng');
                    util.setJsonLocal('waitResponse','splitOrderReportIng');
                    await this.getqueryVerifyList('applySplitOrderList', inputParams)
                    break
                case 'appealReportIng'://部门申诉待审核
                    util.setJsonLocal('buttonType','appealReportIng');
                    util.setJsonLocal('waitResponse','appealReportIng');
                    await this.getQueryApplyVerifyList('applyVerifyList', inputParams)
                    break
                case 'caseHandle'://诉转案,待立案
                    util.setJsonLocal('buttonType','caseHandle');
                    // util.setJsonLocal('buttonType','appealReportIng');
                    // util.setJsonLocal('waitResponse','appealReportIng');
                    await this.caseList('"waitAcceptCase"', inputParams)
                    break    
                case 'queryList':
                    util.setJsonLocal('buttonType','');
                    util.setJsonLocal('waitResponse','');
                    await this.getAllList('allList', inputParams)
                    break
                case 'mySupervision':  // 省级
                    util.setJsonLocal('buttonType','');
                    util.setJsonLocal('waitResponse','');
                    await this.getListSuperviseList('mySupervision', inputParams)
                    break
                case 'supplementInformation':  // 补充完善信息
                    util.setJsonLocal('buttonType','supplementInformation');
                    util.setJsonLocal('waitResponse','supplementInformation');
                    await this.getAllList('allList', inputParams);
                    break
                default:
                    break
                }
            },
            async getNotAcceptComplainList (queryType, inputParams) {//指挥中心待响应
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        place: this.areaId,
                        inputParams: inputParams
                    }
                    
                }
                await Ap1Worker.worker.notAcceptComplainList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            async getNotHandleComplainList(queryType, inputParams) {//指挥中心待处理
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        place: this.areaId,
                        inputParams: inputParams
                    }
                    
                }
                await Ap1Worker.worker.notHandleComplainList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            async getListAwaitReport(queryType, inputParams) {//指挥中心，上报待审核
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        place: this.areaId,
                        inputParams: inputParams
                    }
                    
                }
                await Ap1Worker.worker.listAwaitReport(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            async getListSuperviseToAccept (queryType, inputParams) {//指挥中心.督办待受理
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        place: this.areaId,
                        inputParams: inputParams
                    }
                    
                }
                await Ap1Worker.worker.listSuperviseToAccept(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            async getqueryVerifyList (queryType, inputParams) {//指挥中心.拆单待审核
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        place: this.areaId,
                        inputParams: inputParams,
                    }
                    
                }
                await Ap1Worker.worker.queryVerifyList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            // 部门和企业待处理列表
            async getlistDepEnterpriseAwaitHandle (queryType, inputParams) {
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        inputParams: inputParams,
                        place: this.areaId
                    }
                }
                await Ap1Worker.worker.listDepEnterpriseAwaitHandle(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            // 部门申诉待审核列表
            async getQueryApplyVerifyList (queryType, inputParams) {
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        inputParams: inputParams,
                        place: this.areaId
                    }
                }
                await Ap1Worker.worker.queryApplyVerifyList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            // 部门诉转案,待立案,待处理
            async getCaseList (queryType, inputParams) {
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        type: queryType,
                        inputParams: inputParams,
                        cityId: this.areaId
                    }
                }
                await Ap1Worker.worker.caseList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            //  督办待受理列表,我的督办列表 -- 
            async getListSuperviseList (queryType, inputParams) {
                this.proList = [];
                this.pageIndex = 1;
                const data = {
                    data: {
                        curPage: 1,
                        pageSize: 10,
                        type: queryType,
                        inputParams: inputParams,
                        place: this.areaId
                    }
                }
                await Ap1Worker.supervise.superviseList(data).then(res => {
                    console.log(res.data, 'res-------:')
                    this.goDetail(res.data.list)
                });
            },
            // 诉转案待处理
            async caseList (queryType, inputParams) {
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        inputParams: inputParams,
                        place: this.areaId,
                        type:queryType
                    }
                }
                await Ap1Worker.worker.caseList(params).then(res => {
                    this.goDetail(res.data.list)
                });
            },
            // 投诉件查询列表
            async getAllList (queryType, inputParams) {
                const params = {
                    data:{
                        curPage: 1,
                        pageSize: 10,
                        type: queryType,
                        inputParams: inputParams,
                        place: this.areaId
                    }
                }
                util.setJsonLocal('waitResponse','');
                await Ap1Worker.worker.queryList(params).then((res) => {
                    this.count++
                    this.goDetail(res.data.list)
                })
            },
            // 合并逻辑
            async goDetail (value) {
                // 没数据调用一次查询所有接口数据
                if (value.length === 0 && this.count < 2) {
                    await this.getAllList('allList', this.inputParams)
                } else {
                    if (value.length === 0) {
                        this.$Toast({
                            message: '该投诉件已被退回'
                        });
                    } else {
                        util.setJsonLocal('item', value[0]);
                        this.$store.commit('complaint/getItemList', value[0]);
                        // this.$store.commit('complaint/setHandleWorkbench', 'test');
                        // this.$store.commit('complaint/setBackDetail', 'back');
                        // location.href=`http://localhost:8080/#/complaint/detailList/complaintSheet`
                        if (this.disposeUrl) {
                            window.yyn.invokeJSB(
                                'openWindow', {
                                    openUrl: this.disposeUrl,
                                    isFullScreen: 0,
                                    setTitle: '',
                                    needLoading: 1
                                },
                                cb => {
                                    console.log(cb, 'callback');
                                }
                            );
                        }
                        // this.$router.push('complaint/redirectDetail?type=superviseHandle&main_complain_number=202011091646026080992&messageId=406160&isRead=true');
                        // https://t-tio   complaint/redirectDetail?type=supplementInformation&main_complain_number=202011041421461907215&messageId=450706&isRead=true
                        // console.log(this.disposeUrl);
                        // location.replace(`${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`)
                    }
                    this.count = 0
                }
            },
            isRead () {
                let messageId = localStorage.getItem('messageId') || ''
                this.listdata.map((items, index) => {
                    if (items.id === Number(messageId)) {
                        items.isRead = true
                    }
                })
            },
            // 消息数
            getUnreadQuantity () {
                api.getUnreadQuantity().then(res => {
                    console.log('消息数接口返回值:', res);
                    if (res.ret === 0) {
                        this.dataTab[0].quantity = res.data.total // 消息总数
                        let mq = res.data.modulesQuantity
                        this.dataTab.forEach(item => {
                            for (let i in mq) {
                                if (i === item.code) {
                                    // 如果是招商，角色为'项目管理角色governmentStacff'才设置信息数
                                    if (item.code == 7) {
                                        if (this.$store.state.investment.isGovernmentStacff) {
                                            item.quantity = mq[i]
                                        } else {
                                            item.quantity = 0
                                        }
                                    } else {
                                        item.quantity = mq[i]
                                    }
                                }
                            }
                        })
                    }
                })
            },
            getAsyncData () {
                let data = {
                    moduleCode: '',
                    pageSize: 50
                }
                api.messageList(data).then(res => {
                    if (res.ret === 0) {
                        let cb = res.data.list

                        let tmpArr = []
                        let hasMsg = false
                        let hasOtherMsg = false
                        for (let i = 0; i < cb.length; i++) {
                            // 循环到相等id截止
                            console.log(Number(cb[i].id), '===', Number(this.startId))
                            if (Number(cb[i].id) === Number(this.startId)) {
                                break
                            }
                            console.log(Number(cb[i].moduleCode), '--', Number(this.moduleCode))
                            // 取当前系统消息
                            if (Number(cb[i].moduleCode) === Number(this.moduleCode) || this.moduleCode === '') {
                                tmpArr.push(cb[i])
                            } else {
                                // 其他系统消息
                                hasOtherMsg = true
                            }

                            // 有新消息
                            hasMsg = true
                        }
                        // 存在其他系统消息气泡提示消息

                        console.log(tmpArr, '实时数据')

                        this.startId = cb[0].id
                        console.log(this.startId, ':startId')
                        if (hasMsg) {
                            if (this.scrollTop > 480) {
                                this.newsTip = true
                            } else {
                                // 其他系统有消息
                                if (hasOtherMsg) {
                                    this.newsTip = true
                                }
                                this.listdata = [...tmpArr, ...this.listdata];
                            }
                        }
                    }
                })
            },

            registerAsyn () {
                let ts = this
                window.yyn.registerAsyn('setUnreadMsgCount', function (cb) {
                    console.log('registerAsyn:setUnreadMsgCount触发：', cb)

                    console.log(Number(cb.lastMessageId), '-', Number(ts.startId))
                    if (Number(cb.lastMessageId) !== Number(ts.startId)) {
                        // 距离顶部第二张卡片开始提示
                        console.log(ts.scrollTop, '顶部距离')
                        if (ts.scrollTop > 480) {
                            ts.newsTip = true
                        } else {
                            // 同步实时消息
                            ts.getAsyncData()
                        }
                    }

                    ts.getUnreadQuantity()
                })

                // app onshow
                window.yyn.registerAsyn('onShow', function () {
                    console.log('registerAsyn:onshow')
                    ts.isRead()
                    ts.getUnreadQuantity()
                    ts.getAsyncData()
                    // do onShow
                })

                // h5 onshow
                document.addEventListener('visibilitychange', function () {
                    // ts.isRead()
                    // ts.getUnreadQuantity()
                    // ts.getAsyncData()
                });
            }

        },
        mounted () {
            // 注册jsBridge 更新未读消息数
            this.registerAsyn()
            this.getInitData()
            this.getUnreadQuantity()
        },

        created () {
            let that = this
            this.$store.commit('complaint/setHandleWorkbench', 'test');
            this.$store.commit('complaint/setBackDetail', 'back');

            window.onscroll = function () {
                that.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            }
        },

        beforeCreate () {
            document.title = '消息'
        }

    }
</script>

<style scoped lang="less">
    .newsTip {
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        top: -100px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        width:110px;
        height:34px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.08);
        border-radius:21px;
        font-size: 12px;

        font-weight:400;
        color:rgba(251,138,25,1);

        z-index: 999;

        .xiaoxi{
            width:14px;
            height: 14px;
            margin-right: 4px;
        }
    }

    .top--100 {
        top: -100px;
    }

    .top-20 {
        top: 15px;
        transition: 0.5s all;
    }

    .message {
        width: 100%;
        // height: 100%;
        // overflow: auto;
        background: rgba(251, 251, 251, 1);
        box-sizing: border-box;
        padding: 20px 0 0 12px;

        .nav-box {
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            margin-top: 2px;
            padding-right: 12px;
            margin-bottom: 10px;

            .left-text {
                font-size: 20px;
                font-family: PingFang SC, Arial, sans-serif;
                -webkit-font-smoothing: antialiased;
                font-weight: 700 !important;
                color: rgba(51, 51, 51, 1);
                line-height: 18px;
                text-align: left;
            }

            .right-text {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(54, 179, 116, 1);
                line-height: 14px;
                text-align: right;
            }

        }

        .navlist-box {
            height: 56px;
            box-sizing: border-box;
            padding-top: 6px;
        }

        .msg-list-box {
            box-sizing: border-box;
            padding-right: 12px;

            .items-box {
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
                border-radius: 3px;
                margin-bottom: 12px;

                .title-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 48px;
                    box-sizing: border-box;
                    padding: 0 16px;

                    .category-box {
                        display: flex;
                        align-items: center;

                        .img-box {
                            width: 20px;
                            height: 20px;
                            position: relative;

                            .back-img {
                                width: 100%;
                                height: 100%;
                            }

                            .red-img {
                                width: 12px;
                                height: 12px;
                                position: absolute;
                                top: -5px;
                                right: -5px;
                            }
                        }

                        .text-box {
                            font-size: 14px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: rgba(51, 51, 51, 1);
                            line-height: 14px;
                            margin-left: 10px;
                        }

                    }

                    .times-box {
                        height: 14px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 14px;
                    }
                }

                .content-box {
                    box-sizing: border-box;
                    padding: 15px 11px 15px 16px;

                    .news-title {
                        height: 14px;
                        font-size: 14px;
                        font-family: PingFang SC, Arial, sans-serif;
                        -webkit-font-smoothing: antialiased;
                        font-weight: 700 !important;
                        color: rgba(51, 51, 51, 1);
                        line-height: 14px;
                        margin-bottom: 12px;
                    }

                    .news-text {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 18px;
                    }
                }

                .do-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 45px;
                    box-sizing: border-box;
                    padding: 0 16px;

                    .do-text {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 14px;
                    }

                    .right-icon {
                        width: 9px;
                        height: 14px;
                    }

                }
            }
        }
    }
</style>
